import {
  HHAlert,
  HHStack,
  HHTypography,
} from '@hinge-health/react-component-library';
import { useGetRevenueShares } from '../../hooks/revenue-share-hooks';
import { useGetAllPackagesQuery } from '../../types';
import { cleanTypeNameGraphql } from '../../utils/graphql-utils';
import RevenueSharesList from './revenue-shares-list';

export interface RevenueShareComponentProps {
  clientId: number;
  partnershipIds?: number[];
}

const RevenueShareComponent = ({
  clientId,
  partnershipIds,
}: RevenueShareComponentProps): JSX.Element => {
  // ACCOUNTS-AND-PLAN-MIGRATION: clientId/partnershipIds are client/partnership-scoped, not resolvable via contract_id — will be addressed by the Accounts & Plan migration.
  const { data, isLoading, hasError } = useGetRevenueShares({
    clientId,
    partnershipIds,
  });
  const { data: packagesData } = useGetAllPackagesQuery();
  const availablePackages = packagesData
    ? cleanTypeNameGraphql(packagesData.getAllPackages)
    : [];

  if (!isLoading && hasError) {
    return (
      <HHAlert hhVariant="outlined" severity="error">
        <HHTypography hhVariant="body">
          There was an error loading revenue shares
        </HHTypography>
      </HHAlert>
    );
  }

  return (
    <HHStack direction="column" spacing={4}>
      <HHTypography hhVariant="h2">Revenue Shares</HHTypography>
      <RevenueSharesList
        revenueSharesData={data}
        loading={isLoading}
        availablePackages={availablePackages}
      />
    </HHStack>
  );
};

export default RevenueShareComponent;
